import MarketingLayout from '@web/layout/MarketingLayout'
import { SolutionsPage } from '@web/layout/SolutionsLayout'
import ContactPage from '@web/pages/ContactPage'
import { HomePage } from '@web/pages/HomePage'
import { PropertyMethodologyPage } from '@web/pages/ProductsPages/PropertyMethodologyPage'
import { PropertyPage } from '@web/pages/ProductsPages/PropertyPage'
import { AdaptationPlanningPage } from '@web/pages/SolutionsPages/AdaptationPlanningPage'
import { AssetInfrastructurePlanningPage } from '@web/pages/SolutionsPages/AssetInfrastructurePlanningPage'
import { EmergencyPlanningPage } from '@web/pages/SolutionsPages/EmergencyPlanningPage'
import { LandUsePlanningPage } from '@web/pages/SolutionsPages/LandUsePlanningPage'
import TeamPage from '@web/pages/TeamPage'
import { Navigate, Route } from 'react-router-dom'
import { RootGuard } from '../../src/RootGuard'
export default function MarketingRoutes() {
  return (
    <>
      <Route element={<RootGuard />}>
        <Route element={<MarketingLayout />}>
          <Route index element={<HomePage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="solutions" element={<SolutionsPage />}>
            <Route index element={<Navigate to="resilience-explorer" replace />} />
            <Route path="adaptation-planning" element={<AdaptationPlanningPage />} />
            <Route
              path="asset-infrastructure-planning"
              element={<AssetInfrastructurePlanningPage />}
            />
            <Route path="land-use-planning" element={<LandUsePlanningPage />} />
            <Route path="emergency-planning" element={<EmergencyPlanningPage />} />
          </Route>
          <Route path="products" element={<SolutionsPage />}>
            <Route index element={<Navigate to="property" replace />} />
            <Route path="property" element={<PropertyPage />} />
            <Route path="property/methodology" element={<PropertyMethodologyPage />} />
          </Route>
          <Route path="contact" element={<ContactPage />} />
        </Route>
      </Route>
    </>
  )
}
